import React, { Component } from "react";
import { Redirect, Link } from 'react-router-dom';
import dk from "../../assets/media/images/Responziv/dk.png";
import jobbik from "../../assets/media/images/Responziv/jobbik.png";
import lmp from "../../assets/media/images/Responziv/lmp.png";
import mmm from "../../assets/media/images/Responziv/mmm.png";
import momentum from "../../assets/media/images/Responziv/momentum.png";
import mszp from "../../assets/media/images/Responziv/mszp.png";
import parbeszed from "../../assets/media/images/Responziv/parbeszed.png";
import logos from "../../assets/media/images/Responziv/logos.png";
import{
	MDBRow,
	MDBCol,
	MDBCard,
	MDBNav,
	MDBNavItem,
	MDBNavLink,
	MDBContainer,
} from 'mdbreact';

class FooterResponziv extends Component {

  constructor(props) {
    super(props);
  };

  render() {
    return (
      <MDBContainer style={{padding: 0, maxWidth: "1000px"}}>
      <MDBRow className="m-0">
        <MDBCol middle size="12" className="text-center py-4">
        <img className="logos" src={logos}></img>
        </MDBCol>
			</MDBRow>
			<div className="footer-rectangle p-0">
			<MDBRow className="pt-2 m-0">
				<MDBCol middle size="12" className="text-center pt-4">
          {/*<Link to="/Impresszum">
            <span className="impresszum">Impresszum</span>
          </Link>*/}
        </MDBCol>
        <MDBCol middle size="12" className="text-center py-3">
          <Link to="/AdatkezelesiTajekoztato">
            <span className="adatkezelesi-nyilatk">Adatkezelési tájékoztató</span>
          </Link>
        </MDBCol>
      </MDBRow>
			</div>
      </MDBContainer>


    );
  }
}

export default FooterResponziv;
